// @ts-nocheck
import {faArrowLeft, faCalendar, faClock, faTicketAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {generateLotteriesResults, getTodayFormatted} from "../utils/generateLotteryData";
import * as styles from "./_lovenPagesCls";

const Loterias = () => {
  const navigate = useNavigate();
  const [results, setResults] = useState([]);

  useEffect(() => {
    // Generate all lottery results on component mount
    setResults(generateLotteriesResults());
  }, []);

  // Group results by lottery name
  const groupedResults = results.reduce((acc, result) => {
    if (!acc[result.name]) {
      acc[result.name] = [];
    }
    acc[result.name].push(result);
    return acc;
  }, {});

  return (
    <div className={styles.pageContainerCls}>
      <button
        type="button"
        className={styles.backButtonCls}
        onClick={() => navigate("/lotoven/home")}
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        <span>Volver</span>
      </button>

      <div className={styles.headerCls}>
        <div className={styles.headerIconCls}>
          <FontAwesomeIcon icon={faTicketAlt} />
        </div>
        <h1 className={styles.titleCls}>Resultados Loterías</h1>
        <div className={styles.dateContainerCls}>
          <FontAwesomeIcon
            icon={faCalendar}
            className={styles.calendarIconCls}
          />
          <p className={styles.dateCls}>{getTodayFormatted()}</p>
        </div>
      </div>

      {/* Description */}
      <div className={styles.descriptionBoxCls}>
        <p>Resultados de todas las loterías venezolanas del día de hoy. Incluye Zulia, Triple Táchira, Chance y más.</p>
      </div>

      {/* Grouped Results by Lottery Name */}
      {Object.entries(groupedResults).map(([lotteryName, draws]) => (
        <section
          key={lotteryName}
          className={styles.lotterySectionCls}
        >
          <h2 className={styles.lotterySectionTitleCls}>
            <FontAwesomeIcon
              icon={faTicketAlt}
              className={styles.lotterySectionIconCls}
            />
            {lotteryName}
          </h2>

          <div className={styles.lotteryDrawsGridCls}>
            {draws.map((result, index) => (
              <div
                key={`${lotteryName}-${index++}`}
                className={styles.lotteryCardCls}
              >
                <div className={styles.lotteryCardHeaderCls}>
                  <FontAwesomeIcon
                    icon={faClock}
                    className={styles.clockIconCls}
                  />
                  <span className={styles.cardTimeCls}>{result.time}</span>
                </div>

                <div className={styles.lotteryCardBodyCls}>
                  <div className={styles.numbersContainerCls}>
                    {result.numbers.map((num, idx) => (
                      <div
                        key={`${idx++}`}
                        className={styles.lotteryNumberBoxCls}
                      >
                        {num}
                      </div>
                    ))}
                  </div>

                  <div className={styles.serialContainerCls}>
                    <span className={styles.serialLabelCls}>Serie:</span>
                    <span className={styles.serialValueCls}>{result.serial}</span>
                  </div>
                </div>

                <div className={styles.lotteryCardFooterCls}>
                  <span className={styles.cardDateCls}>{result.date}</span>
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}

      {/* Info Banner */}
      <div className={styles.infoBannerCls}>
        <p>🎟️ Las loterías tradicionales venezolanas son parte de la cultura nacional desde hace décadas</p>
      </div>
    </div>
  );
};

export default Loterias;
